import { Outlet } from "react-router-dom";

// Раньше без почты любая страница возвращала в «Мои данные». Почта нужна
// для уведомлений, рассылок и чека, поэтому её спрашиваем там, где она
// нужна: в окне оплаты и мягкой подсказкой на Главной (решение 22.10).
const ProtectedRoutes = () => <Outlet />;

export default ProtectedRoutes;
